import React from 'react';
import { CURRENCIES } from '../services/currencyService';

function CurrencySelector({ selectedCurrency, onCurrencyChange, loading }) {
  const currencyNames = {
    USD: 'USD $',
    EUR: 'EUR €',
    CNY: 'CNY ¥',
    AED: 'AED د.إ',
    GBP: 'GBP £',
    JPY: 'JPY ¥',
    CAD: 'CAD $',
    AUD: 'AUD $',
    CHF: 'CHF ₣',
    RUB: 'RUB ₽',
    INR: 'INR ₹',
    BRL: 'BRL R$',
    KRW: 'KRW ₩',
    TRY: 'TRY ₺',
    ZAR: 'ZAR R'
  };

  return (
    <div style={{
      position: 'relative',
      display: 'inline-block'
    }}>
      <select
        value={selectedCurrency}
        onChange={(e) => onCurrencyChange(e.target.value)}
        disabled={loading}
        style={{
          padding: '4px 24px 4px 8px',
          background: 'rgba(255,255,255,.15)',
          border: '1px solid rgba(255,255,255,.2)',
          borderRadius: '4px',
          color: '#fff',
          fontSize: '11px',
          fontWeight: '500',
          cursor: loading ? 'not-allowed' : 'pointer',
          outline: 'none',
          appearance: 'none',
          WebkitAppearance: 'none',
          lineHeight: '1',
          height: '22px',
          display: 'flex',
          alignItems: 'center'
        }}
        onMouseEnter={(e) => {
          if (!loading) e.target.style.background = 'rgba(255,255,255,.25)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'rgba(255,255,255,.15)';
        }}
      >
        {CURRENCIES.map(currency => (
          <option 
            key={currency} 
            value={currency}
            style={{ background: '#1a1a2e', color: '#fff' }}
          >
            {currencyNames[currency] || currency}
          </option>
        ))}
      </select>
      <div style={{
        position: 'absolute',
        right: '6px',
        top: '50%',
        transform: 'translateY(-50%)',
        pointerEvents: 'none',
        color: 'rgba(255,255,255,.6)',
        fontSize: '10px'
      }}>
        ▼
      </div>
    </div>
  );
}

export default CurrencySelector;